import React, { memo } from 'react';
import { FileText, Image } from 'lucide-react';

export const FileAttachment = memo(({ file, onClick, isUserMessage }) => {
  const isImage = file.type?.startsWith('image/');
  
  const handleClick = () => {
    if (isImage && onClick) {
      onClick(file);
    }
  };

  return (
    <div
      onClick={handleClick}
      className={`flex items-center gap-2 px-3 py-2 rounded-lg text-xs transition-all duration-200 ${
        isUserMessage 
          ? 'bg-blue-500 bg-opacity-60' 
          : 'bg-gray-100 dark:bg-gray-800'
      } ${isImage ? 'cursor-pointer hover:opacity-80' : ''}`}
    >
      {isImage ? (
        <Image size={14} className="flex-shrink-0" />
      ) : (
        <FileText size={14} className="flex-shrink-0" />
      )}
      <span className="truncate max-w-[120px]" title={file.name}>
        {file.name}
      </span>
    </div>
  );
});

export const FileAttachmentList = memo(({ files, onImageClick, isUserMessage }) => {
  if (!files || files.length === 0) return null;

  return (
    <div className="mb-3">
      <div className="flex flex-wrap gap-2">
        {files.map((file, index) => (
          <FileAttachment
            key={index}
            file={file}
            onClick={onImageClick}
            isUserMessage={isUserMessage}
          />
        ))}
      </div>
    </div>
  );
});